import { execute } from 'utils/API';
import { apiEndoints, httpMethods } from 'utils/constants';
import PropTypes from 'prop-types';
const parseJsonResponse = buffer => {
  const bytes = new Uint8Array(buffer);
  const text =
    typeof TextDecoder !== 'undefined'
      ? new TextDecoder('utf-8').decode(bytes)
      : String.fromCharCode.apply(null, bytes);
  return JSON.parse(text);
};

const getFilenameFromHeaders = headers => {
  const disposition = headers?.['content-disposition'];
  if (!disposition) {
    return null;
  }

  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const basicMatch = disposition.match(/filename="?([^";]+)"?/i);
  return basicMatch?.[1] || null;
};

const normalizePdfResponse = response => {
  if (!response) {
    return response;
  }

  const contentType = response?.headers?.['content-type']?.toLowerCase() || '';

  if (contentType.includes('application/pdf')) {
    const fileName = getFilenameFromHeaders(response.headers) || 'Appraisal.pdf';

    return {
      ...response,
      data: {
        document: {
          documentBody: response.data,
          documentName: fileName,
          contentType: 'application/pdf',
          isBinary: true,
          documentType: {
            name: fileName.replace(/\.pdf$/i, '') || 'Appraisal',
          },
        },
      },
    };
  }

  return {
    ...response,
    data: parseJsonResponse(response.data),
  };
};

const getPDF = async ({ queryKey }) => {
  const response = await execute(
    httpMethods.GET,
    `${apiEndoints.DOCUMENT}/${queryKey[2]}/pdf`,
    { authorization: queryKey[1] },
    {},
    10,
    'arraybuffer',
  );

  return normalizePdfResponse(response);
};

getPDF.propTypes = {
  queryKey: PropTypes.array.isRequired,
};

export { getPDF };
